/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
// import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import {Map, Marker, TileLayer, Popup, FeatureGroup, Polygon, Polyline} from 'react-leaflet'

import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Loader from '../loaders/loader'
import Select from 'react-select'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {getParcelInfo} from '../../lib/path'

class SetDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()

    this.state = {
      activePolygon: false,
      polyline: [],
      polygon: [],
      loading: false,
      points: [],
      custommer: [],
      drivers: [],
      cars: [],
      openTable: false,
      packId: [],
      assignError: '',
      tarh: 'all',
      withOutMarker: [],
      masterPoints: [],
      oddCars: [],
      evenCars: [],
      data: [],
      latCenter: 35.74287570972717,
      lonCenter: 51.54944953647805,
      driverCarId: '',
      listGeo: [],
      deletepoly: false,
      driverId: '',
      carId: '',
      showUpButton: false,
      unmatchAssign: []
    }
  }

  goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, true)
    this.setState({
      loading: true
    })

    sessionStorage.setItem('deletePoly', 'false')

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_GEO}?type=3`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          listGeo: response.data.object
        })
      } else {
        this.setState({
          listGeo: ''
        })
      }
    })
    let {planId} = this.props.match.params

    http
      .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_CARS}?planId=${planId}`, {})
      .then((response) => {
        if (response.data.error === null) {
          let cars = response.data.object
          cars.forEach((item) => {
            item.value = item.carId
            item.label = item.code + ' - ' + item.name + ' - ' + item.plate
          })
          this.setState({
            cars
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?export=true&planId=${planId}&sortBy=geoTitle_ASC`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          var points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }
          this.setState({
            points: response.data.object.result,
            masterPoints: response.data.object.result,
            loading: false
          })

          var withOutPointArr = []

          for (let j = 0; j < points.length; j++) {
            if (this.state.points[j]['latitude'] == null) {
              withOutPointArr.push(this.state.points[j])
            }
          }
          this.setState({
            withOutMarker: withOutPointArr
          })
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_DRIVERS}?planId=${planId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))

          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
        } else {
          alert(JSON.stringify(response.data))
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })
  }

  removeCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.points[id].deliveryPackId,
      invoiceId: this.state.points[id].invoiceId,
      invoiceNum: this.state.points[id].invoiceNum,
      totalAmount: this.state.points[id].totalAmount,
      geo: {
        title: this.state.points[id].geo.title
      },
      payableAmount: this.state.points[id].payableAmount,
      address: this.state.points[id].address,
      buyerName: this.state.points[id].buyerName,
      checked: false
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[id].checked = positionObject.checked
      return {
        points: newpoints
      }
    })

    var index = this.state.custommer.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)
    this.state.custommer.splice(index, 1)
    this.setState(this.state.custommer)
    if (this.state.custommer.length == '0') {
      this.setState({
        openTable: false
      })
    }
  }

  addCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.points[id].deliveryPackId,
      invoiceId: this.state.points[id].invoiceId,
      invoiceNum: this.state.points[id].invoiceNum,
      totalAmount: this.state.points[id].totalAmount,
      geo: {
        title: this.state.points[id].geo.title
      },
      payableAmount: this.state.points[id].payableAmount,
      address: this.state.points[id].address,
      buyerName: this.state.points[id].buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[id].checked = positionObject.checked
      return {
        points: newpoints
      }
    })

    const isFound = this.state.custommer.find((custommer) => custommer.deliveryPackId === positionObject.deliveryPackId)
    if (!isFound) {
      this.setState((prevState) => ({
        custommer: [...prevState.custommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  delete = (rowId) => {
    const positionObject = {
      deliveryPackId: this.state.custommer[rowId].deliveryPackId,
      invoiceId: this.state.custommer[rowId].invoiceId,
      invoiceNum: this.state.custommer[rowId].invoiceNum,
      totalAmount: this.state.custommer[rowId].totalAmount,
      payableAmount: this.state.custommer[rowId].payableAmount,
      address: this.state.custommer[rowId].address,
      buyerName: this.state.custommer[rowId].buyerName,
      checked: false
    }

    var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)
    if (index >= 0) {
      this.setState((prevState) => {
        let newpoints = this.state.points
        // alert(JSON.stringify(newpoints[index]))
        newpoints[index].checked = positionObject.checked
        return {
          points: newpoints
        }
      })
    } else {
    }

    this.state.custommer.splice(rowId, 1)
    this.setState(this.state.custommer)

    if (this.state.custommer.length == '0') {
      this.setState({
        openTable: false
      })
    }
  }

  deleteAllCustomer() {
    let points = this.state.points
    for (let i = 0; i < points.length; i++) {
      this.setState((prevState) => {
        let newpoints = points
        newpoints[i].checked = false
        return {
          points: newpoints
        }
      })
    }

    this.setState({
      custommer: [],
      openTable: false
    })
  }

  Up = (rowId) => {
    if (rowId > 0) {
      let temp = this.state.custommer[rowId - 1]
      this.state.custommer[rowId - 1] = this.state.custommer[rowId]
      this.state.custommer[rowId] = temp
      this.setState(this.state.custommer)
    }
  }
  Down = (rowId) => {
    if (rowId < this.state.custommer.length - 1) {
      let temp = this.state.custommer[rowId + 1]
      this.state.custommer[rowId + 1] = this.state.custommer[rowId]
      this.state.custommer[rowId] = temp
      this.setState(this.state.custommer)
    }
  }

  confirmPoly() {
    let points = this.state.polygon.map((item) => {
      return {
        lat: item[0],
        lon: item[1]
      }
    })
    console.log(points)

    var {planId} = this.props.match.params
    let {tarh} = this.state
    if (tarh == 'all') {
      var dataPoint = {
        planId: planId,
        points,
        evenOdd: false,
        generalPlan: false
      }
    } else if (tarh == 'oddEven') {
      var dataPoint = {
        planId: planId,
        points,
        evenOdd: true,
        generalPlan: false
      }
    } else if (tarh == 'trafic') {
      var dataPoint = {
        planId: planId,
        points,
        evenOdd: false,
        generalPlan: true
      }
    }

    // alert(JSON.stringify(dataPoint))
    this.setState({
      loading: true
    })
    http
      .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYASSIGN}`, dataPoint, {})
      .then((response) => {
        this.setState({
          polygon: [],
          loading: false
        })
        if (response.data.error == null) {
          localStorage.removeItem('pathPolygon')

          var temp = this.state.custommer
          response.data.object.result.forEach(function(newItem) {
            var found = false
            temp.forEach(function(oldItem) {
              if (newItem.deliveryPackId == oldItem.deliveryPackId) {
                found = true
              }
            })
            if (found === false) {
              temp.push(newItem)
            }
          })

          this.setState({
            custommer: temp,
            openTable: true
          })

          for (let i = 0; i < this.state.custommer.length; i++) {
            const positionObject = {
              deliveryPackId: this.state.custommer[i].deliveryPackId,
              invoiceId: this.state.custommer[i].invoiceId,
              invoiceNum: this.state.custommer[i].invoiceNum,
              totalAmount: this.state.custommer[i].totalAmount,
              payableAmount: this.state.custommer[i].payableAmount,
              address: this.state.custommer[i].address,
              geo: {
                title: this.state.custommer[i].geo.title
              },
              buyerName: this.state.custommer[i].buyerName,
              checked: true
            }
            // alert(JSON.stringify(positionObject))
            var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)

            if (index >= 0) {
              this.setState((prevState) => {
                let newpoints = this.state.points
                newpoints[index].checked = positionObject.checked
                return {
                  points: newpoints
                }
              })
            }
          }
        } else if (response.data.error == 'EMPTY_RESULTS') {
          message.error('در این ناحیه سفارشی موجود نیست')
        } else {
          message.error(response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  Sort() {
    let {custommer} = this.state
    const token = sessionStorage.getItem('accessToken')

    for (var a = 0; a < custommer.length; a++) {
      this.state.packId.push(custommer[a]['deliveryPackId'])
    }
    var sortData = {
      deliveryPackIds: this.state.packId
    }

    http
      .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_SORT}`, sortData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            custommer: response.data.object.result
          })
        } else if (response.data.error == 'EMPTY_RESULTS') {
          message.error('سفارشی ارسال نشده است')
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  handleMarkerClick = (
    index,
    deliveryPackId,
    invoiceId,
    invoiceNum,
    totalAmount,
    payableAmount,
    Address,
    geoTitle,
    buyerName,
    position
  ) => {
    // let positionObject = {
    //   deliveryPackId: deliveryPackId,
    //   invoiceId: invoiceId,
    //   invoiceNum: invoiceNum,
    //   totalAmount: totalAmount,
    //   payableAmount: payableAmount,
    //   address: Address,
    //   geo: {
    //     title: geoTitle,
    //   },
    //   buyerName: buyerName,
    //   checked: true,
    // };
    // this.setState((prevState) => {
    //   let newpoints = this.state.points;
    //   newpoints[index].checked = positionObject.checked;
    //   return {
    //     points: newpoints,
    //   };
    // });
    // const isFound = this.state.custommer.find(
    //   (custommer) => custommer.deliveryPackId === positionObject.deliveryPackId
    // );
    // if (!isFound) {
    //   this.setState((prevState) => ({
    //     custommer: [...prevState.custommer, positionObject],
    //     openTable: true,
    //   }));
    // } else {
    //   message.error("این مشتری قبلا به لیست اضافه شده است");
    // }
  }

  assign() {
    let {custommer} = this.state
    const {planId} = this.props.match.params
    var driver = this.state.driverId === '' || this.state.driverId === null ? '' : this.state.driverId.personId
    var cartype = this.state.carId === '' || this.state.carId === null ? '' : this.state.carId.carId
    if (driver == '') {
      this.setState({
        assignError: 'رساننده را انتخاب کنید'
      })
    } else if (cartype == '') {
      this.setState({
        assignError: 'اتومبیل را انتخاب کنید'
      })
    } else {
      this.setState({
        setAssign: true
      })

      for (var a = 0; a < custommer.length; a++) {
        this.state.packId.push(custommer[a]['deliveryPackId'])
      }

      const assignData = {
        planId: planId,
        driverId: driver,
        carId: cartype,
        deliveryPackIds: this.state.packId
      }

      http
        .post(`${RETAIL.RETAIL_COMPANY_PLAN_ASSIGN}`, assignData, {})
        .then((response) => {
          this.setState({
            setAssign: false
          })
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            this.setState({
              setAssign: false,
              driverId: '',
              carId: ''
            })
            message.success('سفارش ها به رساننده مورد نظر اختصاص یافتند')
            if (response.data.object !== null) {
              if (response.data.object && response.data.object.length > 0) {
                this.setState({
                  unmatchAssign: response.data.object,
                  unMatchModal: true
                })
              } else {
                this.updatePage()
              }
            } else {
              this.updatePage()
            }
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          this.setState({
            setAssign: false
          })
        })
    }
  }
  updatePage = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    const {planId} = this.props.match.params

    this.setState({
      unMatchModal: false,
      loading: true
    })
    http
      .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_CARS}?planId=${planId}`, {})
      .then((response) => {
        if (response.data.error === null) {
          let cars = response.data.object
          cars.forEach((item) => {
            item.value = item.carId
            item.label = item.code + ' - ' + item.name + ' - ' + item.plate
          })
          this.setState({
            cars
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
    http
      .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_DRIVERS}?planId=${planId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))

          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
        } else {
          alert(JSON.stringify(response.data))
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?export=true&planId=${planId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            setAssign: false
          })

          let points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }

          // alert('2')
          this.setState({
            points: points,
            loading: false,
            custommer: [],
            openTable: false,
            packId: []
          })
        }
        if (response.data.error == 'EMPTY_RESULTS') {
          this.setState({
            points: [],
            custommer: [],
            openTable: false,
            packId: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeTarh(e) {
    this.setState({
      tarh: e.target.value,
      loading: true
    })
    var {planId} = this.props.match.params

    if (e.target.value == 'oddEven') {
      var data = {
        planId: planId,
        evenOdd: true
      }
      http
        .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYTRAFFICPLAN}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            var points = response.data.object.result
            for (let i = 0; i < points.length; i++) {
              points[i]['checked'] = false
              points[i]['geoTitle'] = points[i]['geo'].title
            }
            this.setState({
              points: response.data.object.result,
              loading: false
            })

            for (let i = 0; i < this.state.custommer.length; i++) {
              const positionObject = {
                deliveryPackId: this.state.custommer[i].deliveryPackId,
                invoiceId: this.state.custommer[i].invoiceId,
                invoiceNum: this.state.custommer[i].invoiceNum,
                totalAmount: this.state.custommer[i].totalAmount,
                payableAmount: this.state.custommer[i].payableAmount,
                address: this.state.custommer[i].address,
                buyerName: this.state.custommer[i].buyerName,
                checked: true
              }
              var index = this.state.points.findIndex(
                (points) => points.deliveryPackId === positionObject.deliveryPackId
              )

              if (index >= 0) {
                this.setState((prevState) => {
                  let newpoints = this.state.points
                  newpoints[index].checked = positionObject.checked
                  return {
                    points: newpoints
                  }
                })
              }
            }
          } else {
            this.setState({
              points: []
            })
            // message.error(response.data.description)
          }
          // alert(JSON.stringify(response.data))
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else if (e.target.value == 'trafic') {
      var data = {
        planId: planId,
        evenOdd: false
      }
      http
        .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYTRAFFICPLAN}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            var points = response.data.object.result
            for (let i = 0; i < points.length; i++) {
              points[i]['checked'] = false
              points[i]['geoTitle'] = points[i]['geo'].title
            }

            this.setState({
              points: response.data.object.result,
              loading: false
            })

            for (let i = 0; i < this.state.custommer.length; i++) {
              const positionObject = {
                deliveryPackId: this.state.custommer[i].deliveryPackId,
                invoiceId: this.state.custommer[i].invoiceId,
                invoiceNum: this.state.custommer[i].invoiceNum,
                totalAmount: this.state.custommer[i].totalAmount,
                payableAmount: this.state.custommer[i].payableAmount,
                address: this.state.custommer[i].address,
                buyerName: this.state.custommer[i].buyerName,
                checked: true
              }
              var index = this.state.points.findIndex(
                (points) => points.deliveryPackId === positionObject.deliveryPackId
              )

              if (index >= 0) {
                this.setState((prevState) => {
                  let newpoints = this.state.points
                  newpoints[index].checked = positionObject.checked
                  return {
                    points: newpoints
                  }
                })
              }
            }
          } else {
            this.setState({
              points: []
            })
            // message.error(response.data.description)
          }
          // alert(JSON.stringify(response.data))
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else if (e.target.value == 'all') {
      http
        .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?export=true&planId=${planId}`, {})
        .then((response) => {
          if (response.data.error == null) {
            var points = response.data.object.result
            for (let i = 0; i < points.length; i++) {
              points[i]['checked'] = false
              points[i]['geoTitle'] = points[i]['geo'].title
            }
            this.setState({
              points: response.data.object.result,
              loading: false
            })

            for (let i = 0; i < this.state.custommer.length; i++) {
              const positionObject = {
                deliveryPackId: this.state.custommer[i].deliveryPackId,
                invoiceId: this.state.custommer[i].invoiceId,
                invoiceNum: this.state.custommer[i].invoiceNum,
                totalAmount: this.state.custommer[i].totalAmount,
                payableAmount: this.state.custommer[i].payableAmount,
                address: this.state.custommer[i].address,
                buyerName: this.state.custommer[i].buyerName,
                checked: true
              }
              var index = this.state.points.findIndex(
                (points) => points.deliveryPackId === positionObject.deliveryPackId
              )

              if (index >= 0) {
                this.setState((prevState) => {
                  let newpoints = this.state.points
                  newpoints[index].checked = positionObject.checked
                  return {
                    points: newpoints
                  }
                })
              }
            }

            var withOutPointArr = []

            for (let j = 0; j < points.length; j++) {
              if (this.state.points[j]['latitude'] == null) {
                withOutPointArr.push(this.state.points[j])
              }
            }
            this.setState({
              withOutMarker: withOutPointArr
            })
          } else {
            this.setState({
              points: []
            })
            // message.error('در این محدوده زمانی سفارشی موجود نیست');
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  filterCars(e) {
    let {planId} = this.props.match.params
    var value = e.target.value
    if (value == 'even') {
      http
        .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_CARS}?planId=${planId}`, {})
        .then((response) => {
          if (response.data.error == null) {
            let cars = response.data.object
            let evenCars = []
            for (let i = 0; i < cars.length; i++) {
              if (cars[i]['evenPlate']) {
                evenCars.push(cars[i])
              }
            }
            this.setState({
              cars: evenCars
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (value == 'odd') {
      http
        .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_CARS}?planId=${planId}`, {})
        .then((response) => {
          if (response.data.error == null) {
            let cars = response.data.object
            let oddCars = []
            for (let i = 0; i < cars.length; i++) {
              if (!cars[i]['evenPlate']) {
                oddCars.push(cars[i])
              }
            }
            this.setState({
              cars: oddCars
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (value == 'pair') {
      http
        .get(`${RETAIL.REPORT_RETAIL_LIST_FREE_CARS}?planId=${planId}`, {})
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              cars: response.data.object
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      this.setState({
        cars: []
      })
    }
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1
      if (a[key] > b[key]) return 1
      return 0
    }
  }

  sortBy(key) {
    let arrayCopy = this.state.points
    arrayCopy.sort(this.compareBy(key))
    this.setState({data: arrayCopy})
  }

  changeDriver(e) {
    let target = e.target
    this.setState({
      driverCarId: Number(target.options[target.selectedIndex].getAttribute('data-carid'))
    })
  }

  filter() {
    let {planId} = this.props.match.params
    let geoId = document.getElementById('geoId').value
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?planId=${planId}&geoId=${geoId}`, {})
      .then((response) => {
        this.setState({
          points: []
        })
        if (response.data.error == null) {
          var points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }

          this.setState({
            points: response.data.object.result,
            loading: false
          })

          for (let i = 0; i < this.state.custommer.length; i++) {
            const positionObject = {
              deliveryPackId: this.state.custommer[i].deliveryPackId,
              invoiceId: this.state.custommer[i].invoiceId,
              invoiceNum: this.state.custommer[i].invoiceNum,
              totalAmount: this.state.custommer[i].totalAmount,
              payableAmount: this.state.custommer[i].payableAmount,
              address: this.state.custommer[i].address,
              buyerName: this.state.custommer[i].buyerName,
              checked: true
            }
            var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)

            if (index >= 0) {
              this.setState((prevState) => {
                let newpoints = this.state.points
                newpoints[index].checked = positionObject.checked
                return {
                  points: newpoints
                }
              })
            }
          }
        } else {
          this.setState({
            points: []
          })
        }
      })
  }

  selectedDriver = (driverId) => {
    if (driverId === null) {
      this.setState({
        driverId: '',
        carId: ''
      })
    } else {
      this.setState(
        {
          driverId
        },
        () => {
          let cars = this.state.cars
          let findDriverCar = cars.find((item) => item.carId === driverId.carId)
          if (findDriverCar) {
            this.setState({
              carId: findDriverCar
            })
          }
        }
      )
    }
  }
  selectCar = (carId) => {
    this.setState({
      carId
    })
  }
  deleteShape() {}

  handleScroll = () => {
    const scrollY = window.scrollY //Don't get confused by what's scrolling - It's not the window
    if (scrollY > 200) {
      this.setState({
        showUpButton: true
      })
    } else {
      this.setState({
        showUpButton: false
      })
    }
  }

  getMarkers() {
    let points = this.state.points
    const array = []
    points.forEach((item) => {
      if (item.latitude && item.longitude) {
        array.push({
          location: [item.latitude, item.longitude],
          ...item
        })
      }
    })
    return array
  }

  getPolylineMarker() {
    let points = this.state.polyline
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lng) {
        array.push([item.lat, item.lng])
      }
    })
    return array
  }

  togglePolygon = () => {
    this.setState({
      activePolygon: !this.state.activePolygon
    })
  }

  setPoint = (e) => {
    if (this.state.activePolygon && !this.state.polygon.length) {
      const polyline = this.state.polyline
      polyline.push(e.latlng)
      this.setState(
        {
          polyline
        },
        () => {
          this.getMarkers()
        }
      )
    }
  }

  hoverMap = (e) => {
    // const polyline = this.state.polyline
    // if (polyline.length) {
    //   polyline[polyline.length] = e.latlng
    //   this.setState({
    //     polyline
    //   })
    // }
  }

  makePolygon = () => {
    this.setState({
      polygon: [...this.getPolylineMarker(), this.getPolylineMarker()[0]],
      polyline: []
    })
  }

  makePolygoneByPoint = (point) => {
    console.log(point)
    const polylinesPoint = this.getPolylineMarker()
    if (polylinesPoint.length > 2) {
      const firstPoint = polylinesPoint[0]
      if (firstPoint[0] === point[0] && firstPoint[1] === point[1]) {
        this.makePolygon()
      }
    }
  }

  selectCustomer = (item, index) => {
    if (!this.state.activePolygon) {
      let positionObject = {
        deliveryPackId: item.deliveryPackId,
        invoiceId: item.invoiceId,
        invoiceNum: item.invoiceNum,
        totalAmount: item.totalAmount,
        payableAmount: item.payableAmount,
        address: item.address,
        geo: {
          title: item.geoTitle
        },
        buyerName: item.buyerName,
        checked: true
      }

      this.setState((prevState) => {
        let newpoints = this.state.points
        newpoints[index].checked = positionObject.checked
        return {
          points: newpoints
        }
      })
      const isFound = this.state.custommer.find(
        (custommer) => custommer.deliveryPackId === positionObject.deliveryPackId
      )
      if (!isFound) {
        this.setState((prevState) => ({
          custommer: [...prevState.custommer, positionObject],
          openTable: true
        }))
      } else {
        message.error('این مشتری قبلا به لیست اضافه شده است')
      }
    }
  }

  drawEnd = (e) => {
    let layer = e.layer
    let type = e.layerType
    if (type !== 'marker') {
      const coords = layer.getLatLngs()
      var {planId} = this.props.match.params
      let {tarh} = this.state

      const points = coords.map((item) => {
        return {
          lat: item.lat,
          lon: item.lng
        }
      })
      console.log(points)
      if (tarh == 'all') {
        var dataPoint = {
          planId: planId,
          points: points,
          evenOdd: false,
          generalPlan: false
        }
      } else if (tarh == 'oddEven') {
        var dataPoint = {
          planId: planId,
          points: points,
          evenOdd: true,
          generalPlan: false
        }
      } else if (tarh == 'trafic') {
        var dataPoint = {
          planId: planId,
          points: points,
          evenOdd: false,
          generalPlan: true
        }
      }
    }
  }

  render() {
    const {points} = this.state
    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const selected = renderToStaticMarkup(<img src={require('../../image/finishPack.png')} />)

    const bluePin = renderToStaticMarkup(
      <img src={require('../../image/bluePin.png')} style={{height: 15, width: 15}} />
    )

    const classTable = this.state.openTable ? 'appointedCustommer' : 'appointedCustommer hide'

    var initialVal = 0
    var sumPrice = this.state.custommer.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    var initialVal = 0
    var sumUnassigned = this.state.points.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    return (
      <div className="rtl body position-relative" onScroll={this.onScroll} ref={this.myRef}>
        <Loader show={this.state.loading} />
        {/*<AdminMenu/>*/}
        <div className="Packs wrapperIframe">
          <div className="titlePacks">
            <h5>لیست همه فاکتور ها</h5>
            <select className="form-control col-2" id="tarh" onChange={this.changeTarh.bind(this)}>
              <option value="all">لیست کلی</option>
              <option value="oddEven">لیست کنترل آلودگی</option>
              <option value="trafic">لیست طرح ترافیک</option>
            </select>
            {this.state.polygon.length ? (
              <div className="btnMap">
                <button className="setPolygon btn btn-sm" onClick={this.confirmPoly.bind(this)}>
                  تایید چند ضلعی
                </button>
              </div>
            ) : null}
          </div>

          <div className="addressMap position-relative">
            <section className="position-absolute" style={{zIndex: 999}}>
              <button
                title={this.state.activePolygon ? 'غیر فعال کردن' : 'فعال کردن'}
                className={this.state.activePolygon ? 'active-polygon' : 'polygon'}
                onClick={this.togglePolygon}
              >
                <img src={require('../../image/polygon.png')} width={30} />
              </button>

              {this.state.polygon.length && this.state.activePolygon ? (
                <button
                  className="polygon mx-3 text-danger p-1"
                  onClick={() => this.setState({polygon: [], polyline: []})}
                >
                  حذف چند ضلعی
                </button>
              ) : null}

              {this.state.polyline.length >= 3 && this.state.activePolygon && (
                <button className="polygon mx-3 p-1 text-success" onClick={this.makePolygon}>
                  ساخت چند ضلعی
                </button>
              )}
            </section>
            <Map
              center={[35.6892, 51.389]}
              zoom={10}
              style={{height: '500px'}}
              onclick={this.setPoint}
              onmousemove={this.hoverMap}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item, index) => (
                <Marker
                  icon={
                    item.checked
                      ? divIcon({
                          html: selected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                      : divIcon({
                          html: unSelected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                  }
                  position={item.location}
                  title={item.buyerName + '- شماره فاکتور : ' + item.invoiceNum}
                  onClick={() => this.selectCustomer(item, index)}
                />
              ))}

              {this.getPolylineMarker().map((item, index) => (
                <Marker
                  position={item}
                  icon={divIcon({
                    html: bluePin
                  })}
                  onClick={() => this.makePolygoneByPoint(item)}
                />
              ))}

              <Polyline positions={this.getPolylineMarker()} />
              {this.state.activePolygon ? <Polygon positions={this.state.polygon} /> : null}
            </Map>
          </div>
        </div>
        <div className="wrapperIframe position-sticky" style={{top: 60, zIndex: 100}}>
          <div className="container-fluid border-bottom p-3 bg-white my-2 ">
            <div className="row align-items-center align-content-center">
              <div className="col-6">
                <div className="basketFilterComponent w-100">
                  <div className="w-100">
                    <div className="w-75">
                      <label>منطقه شهرداری :</label>
                      <select className="form-control" id="geoId" name="geoId">
                        <option value="">------</option>
                        {this.state.listGeo.map((geo, index) => (
                          <option value={geo.id}>{geo.title}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="filterOption">
                    <button className="confirmFilter" onClick={this.filter.bind(this)}>
                      جست و جو
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className={classTable}>
                  <form className="assignForm w-100" onSubmit={this.submit.bind(this)}>
                    <div className="my-2">
                      <label className="mb-2 mr-sm-2">رساننده</label>
                      <Select
                        value={this.state.driverId}
                        onChange={this.selectedDriver}
                        options={this.state.drivers}
                        isClearable={true}
                        placeholder=""
                      />
                    </div>
                    <div className="my-2">
                      <label className="mb-2 mr-sm-2">اتومبیل</label>
                      <Select
                        value={this.state.carId}
                        onChange={this.selectCar}
                        options={this.state.cars}
                        isClearable={true}
                        placeholder=""
                      />
                    </div>
                    <div className="my-2">
                      <button
                        className="btn btn-primary btn-sm"
                        disabled={this.state.setAssign ? true : false}
                        onClick={this.assign.bind(this)}
                      >
                        تخصیص
                      </button>
                      <p className="errorText">{this.state.assignError}</p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.custommer.length > 0 && (
          <div className="Packs wrapperIframe position-relative">
            <div className={classTable}>
              <div className="tableComponent">
                <div className="titlePacks p-2 d-flex flex-row justify-content-between">
                  <h5>فاکتور های انتخاب شده</h5>
                  <div>
                    <button className="setPolygon btn btn-sm" onClick={this.Sort.bind(this)}>
                      مرتب سازی لیست
                    </button>
                    <button className="cancelPolygon btn btn-sm" onClick={this.deleteAllCustomer.bind(this)}>
                      حذف لیست
                    </button>
                  </div>
                </div>
                <table className="baseTable">
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>شناسه</td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>

                    <td className="priceCell"> قابل پرداخت (ریال)</td>
                    <td>منطقه</td>
                    <td>آدرس</td>
                    <td>نام خریدار</td>
                    <td>جزییات</td>
                    <td>بالا</td>
                    <td>پایین</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.custommer.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.deliveryPackId}</td>
                      <td>{item.invoiceId}</td>
                      <td>{item.invoiceNum}</td>
                      <td className="priceCell">{accounting.formatMoney(item.payableAmount, '', ',')}</td>
                      <td>{item.geo.title}</td>
                      <td>{item.address}</td>
                      <td>{item.buyerName}</td>
                      <td>
                        <Link to={`/subFactors/${item.deliveryPackId}`} target="_blank">
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                      <td>
                        <button>
                          <img src={require('../../image/up.svg')} onClick={() => this.Up(index)} />
                        </button>
                      </td>
                      <td>
                        <button>
                          <img src={require('../../image/down.svg')} onClick={() => this.Down(index)} />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(index)}>
                          <img src={require('../../image/trash.svg')} />
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>مجموع قابل پرداخت</td>
                    <td colSpan={1} className="priceCell">
                      {accounting.formatMoney(sumPrice, '', ',') + ' ریال '}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        )}
        <div className="Packs wrapperIframe">
          <div className="tableComponent" style={points.length == '0' ? {display: 'none'} : {display: 'block'}}>
            <table className="baseTable">
              <tr className="firstRow">
                <td>ردیف</td>
                <td>شناسه</td>
                <td onClick={() => this.sortBy('invoiceId')}>
                  شناسه فاکتور{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('invoiceNum')}>
                  شماره فاکتور{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('payableAmount')} className="priceCell">
                  {' '}
                  قابل پرداخت (ریال)
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('geoTitle')}>
                  {' '}
                  منطقه{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td>آدرس</td>
                <td>موقعیت روی نقشه</td>
                <td>خریدار</td>
                <td>جزییات</td>
                <td>درج</td>
              </tr>
              {this.state.points.map((items, index) => (
                <tr style={items.checked ? {backgroundColor: '#efffae'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{items.deliveryPackId}</td>
                  <td>{items.invoiceId}</td>
                  <td>{items.invoiceNum}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                  <td>{items.geo.title}</td>
                  <td>{items.address}</td>
                  <td>{items.latitude == null ? 'ندارد' : 'دارد'}</td>
                  <td>{items.buyerName}</td>
                  <td>
                    <Link to={`/subFactors/${items.deliveryPackId}`} target="_blank">
                      <img src={require('../../image/details.svg')} />
                    </Link>
                  </td>
                  <td>
                    <button
                      onClick={() => this.addCustomer({index})}
                      style={items.checked ? {display: 'none'} : {display: 'inline-block'}}
                    >
                      <img src={require('../../image/add.svg')} />
                    </button>

                    <button
                      onClick={() => this.removeCustomer({index})}
                      style={items.checked ? {display: 'inline-block'} : {display: 'none'}}
                    >
                      <img src={require('../../image/minus.svg')} />
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={4}>مجموع</td>
                <td className="priceCell">{accounting.formatMoney(sumUnassigned, '', ',')}</td>
                <td colSpan={6} />
              </tr>
            </table>
          </div>
        </div>

        {this.state.showUpButton && (
          <button
            className="position-fixed goUp border-0"
            onClick={this.goUp}
            style={{
              bottom: 10,
              left: 10,
              width: 50,
              height: 50,
              borderRadius: '50%'
            }}
          >
            برو بالا
          </button>
        )}
        <Modal isOpen={this.state.unMatchModal} toggle={() => this.updatePage()}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h3 className="text-center font-weight-bold">لیست مرسوله هایی که در به‌روزرسان وضعیتشان تغییر نکرده است</h3>
            <table className="baseTable">
              <tr className="firstRow" style={{fontSize: '2em'}}>
                <th>ردیف</th>
                <th>شماره مرسوله</th>
              </tr>
              {this.state.unmatchAssign.map((item, index) => (
                <tr style={{fontSize: '2em'}}>
                  <th>{index + 1}</th>
                  <th>
                    <a href={getParcelInfo({parcelId: item})} target="_blank">
                      {item}
                    </a>
                  </th>
                </tr>
              ))}
            </table>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

function getGeoJson() {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: [[-122.47979164123535, 37.830124319877235], [-122.47721672058105, 37.809377088502615]]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [-122.46923446655273, 37.80293476836673]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [-122.48399734497069, 37.83466623607849]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [-122.47867584228514, 37.81893781173967]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-122.48069286346434, 37.800637436707525],
              [-122.48069286346434, 37.803104310307276],
              [-122.47950196266174, 37.803104310307276],
              [-122.47950196266174, 37.800637436707525],
              [-122.48069286346434, 37.800637436707525]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-122.48103886842728, 37.833075326166274],
              [-122.48065531253813, 37.832558431940114],
              [-122.4799284338951, 37.8322660885204],
              [-122.47963070869446, 37.83231693093747],
              [-122.47948586940764, 37.832467339549524],
              [-122.47945636510849, 37.83273426112019],
              [-122.47959315776825, 37.83289737938241],
              [-122.48004108667372, 37.833109220743104],
              [-122.48058557510376, 37.83328293020496],
              [-122.48080283403395, 37.83332529830436],
              [-122.48091548681259, 37.83322785163939],
              [-122.48103886842728, 37.833075326166274]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-122.48043537139893, 37.82564992009924],
              [-122.48129367828368, 37.82629397920697],
              [-122.48240947723389, 37.82544653184479],
              [-122.48373985290527, 37.82632787689904],
              [-122.48425483703613, 37.82680244295304],
              [-122.48605728149415, 37.82639567223645],
              [-122.4898338317871, 37.82663295542695],
              [-122.4930953979492, 37.82415839321614],
              [-122.49700069427489, 37.821887146654376],
              [-122.4991464614868, 37.82171764783966],
              [-122.49850273132326, 37.81798857543524],
              [-122.50923156738281, 37.82090404811055],
              [-122.51232147216798, 37.823344820392535],
              [-122.50150680541992, 37.8271414168374],
              [-122.48743057250977, 37.83093781796035],
              [-122.48313903808594, 37.82822612280363],
              [-122.48043537139893, 37.82564992009924]
            ]
          ]
        }
      }
    ]
  }
}

export default SetDrivers
